import React from "react";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import NotInterestedIcon from "@material-ui/icons/NotInterested";

interface SkippedItemBannerProps {
  itemLabel?: string;
  motifLabel: string;
  subtitle?: string;
  onClear?: () => void;
  readOnly?: boolean;
}

const SkippedItemBanner = ({
  itemLabel = "Image",
  motifLabel,
  subtitle,
  onClear,
  readOnly,
}: SkippedItemBannerProps) => {
  const resolvedSubtitle =
    subtitle ||
    `Cette ${itemLabel.toLowerCase()} a été exclue de la labellisation.`;

  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px 24px",
        gap: "12px",
        textAlign: "center",
        maxWidth: 280,
        margin: "0 auto",
      }}
    >
      {onClear && !readOnly && (
        <IconButton
          onClick={onClear}
          title="Annuler le passage"
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            color: "#757575",
            padding: 6,
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      )}
      <div
        style={{
          width: 52,
          height: 52,
          borderRadius: "50%",
          backgroundColor: "rgb(241 241 241)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#616161",
          flexShrink: 0,
        }}
      >
        <NotInterestedIcon style={{ fontSize: 26 }} />
      </div>
      <div>
        <span
          style={{
            display: "block",
            fontSize: "0.7rem",
            color: "#757575",
            textTransform: "uppercase",
            letterSpacing: "0.08em",
            fontWeight: 600,
            marginBottom: 6,
          }}
        >
          {itemLabel} passée
        </span>
        <span
          style={{
            fontSize: "1.05rem",
            fontWeight: 700,
            color: "#424242",
            lineHeight: 1.3,
          }}
        >
          {motifLabel}
        </span>
      </div>
      <div
        style={{
          fontSize: "0.85rem",
          color: "#939393",
          lineHeight: 1.45,
          fontStyle: "italic",
        }}
      >
        {resolvedSubtitle}
      </div>
    </div>
  );
};

export default SkippedItemBanner;
